import {
  Card,
  CardContent,
  styled
} from "@mui/material";

export const StyledCardContainer = {
  TitleContainer: styled('div')(({ theme }) => ({
    backgroundColor: `${theme.palette.primary.main}`,
    borderBottom: "1px solid green",
    boxSizing: "border-box",
    textAlign: "center",
    color: "white",
  })),
  Card: styled(Card)(({ theme }) => ({
    marginTop: 20,
    width: "100%",
  })),
  CardContent: styled(CardContent)(({ theme }) => ({
    padding: 10,
    minHeight: "250px",
    maxHeight: "350px",
    overflow: "auto",
  })),
}
